import NotificationsAdapter from './base';

export default class Notification extends NotificationsAdapter {
  modelNamePlural = 'notifications';
}
